console.log('components');

import './components/slider';
import './components/burger';
